// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"ae13dc9a","585":"37870af5"}[chunkId] + ".chunk.js";
};